/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import styled from "@emotion/styled/macro";
import LinkView from "../link/LinkView";
import CheckboxView from "../checkbox/CheckBoxView";
import DoneIcon from "@mui/icons-material/Done";
import { v4 as uuidv4 } from "uuid";
import {
  CLICK_AND_SELECT_LABEL,
  cursorPointerRelPos,
  DELETE_LABEL,
  FONT_WEIGHT_600,
  NO_DATA_FOUND_TEXT,
  partTableStyles,
  SOURCE,
  TABLE_CELL_STYLE,
  UPDATE_LABEL,
  WIDTH_100,
} from "../../../utils/constants/GlobalConstants";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./DataTable.css";
import {
  CANCELLED_HEAD_CELLS,
  DC_HEAD_CELLS,
  HISTORY_HEAD_CELLS,
  MAIN_HEAD_CELLS,
  PARTS_HEAD_CELLS,
  PARTS_INSIDE_HEAD_CELLS,
  PARTS_MAINTENANCE_HEAD_CELLS,
  STATUS,
  STORE_HEAD_CELLS,
} from "../../../utils/constants/GlobalFormConstants";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(229, 231, 243)",
    paddingLeft: 10,
  },
  [`&.${tableCellClasses.body}`]: {
    paddingLeft: 10,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}
function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <StyledTableRow>
        {headCells.map((headCell) =>
          headCell.id === "checkbox" ? (
            <StyledTableCell
              sx={TABLE_CELL_STYLE}
              key={headCell.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <DoneIcon />
            </StyledTableCell>
          ) : headCell.id === "status" ? (
            <StyledTableCell
              sx={TABLE_CELL_STYLE}
              key={headCell.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell?.label}
            </StyledTableCell>
          ) : (
            <StyledTableCell
              sx={FONT_WEIGHT_600}
              key={headCell.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          )
        )}
      </StyledTableRow>
    </TableHead>
  );
}

const DataTable = (props) => {
  const dense = true;
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState(
    props?.source === "main-Cancelled DEBI 's" ? "created" : "modified"
  );
  const [selected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rows, setRows] = React.useState([]);
  const [val, setVal] = React.useState("");
  const [fullData, setFullData] = React.useState(null);
  React.useEffect(() => {
    if (
      props?.source === SOURCE.MAIN ||
      props?.source === SOURCE.INPROGRESS ||
      props?.source === SOURCE.CANCELLED ||
      props?.source === SOURCE.HISTORY
    ) {
      props.changePageNoAndSize(page, rowsPerPage);
    }
  }, [page, rowsPerPage]);
  React.useEffect(() => {
    if (
      props?.source === SOURCE.MAIN ||
      props?.source === SOURCE.INPROGRESS ||
      props?.source === SOURCE.CANCELLED ||
      props?.source === SOURCE.HISTORY
    ) {
      props.onSortApicall(order, orderBy);
    }
  }, [order, orderBy]);
  React.useEffect(() => {
    if (props?.source === SOURCE.CANCELLED) {
        setOrderBy("created");
        setOrder("desc");
    } else{
      setOrderBy("modified");
      setOrder("desc");
    }
  }, [props?.sourceChanged]);
  React.useEffect(() => {
    setPage(0);
    setRowsPerPage(5);
  }, [props.value, orderBy]);
  React.useEffect(() => {
    let formattedData = [];
    if (props.source === SOURCE.DC) {
      formattedData = props.rows
        ? props.rows.map((dc) => ({
            checkbox: "",
            name: dc.distributionCenterName,
            city: dc.distributionCity,
          }))
        : [];
    } else if (props.source === SOURCE.MAIN) {
      formattedData = props.rows
        ? props.rows.map((item) => ({
            debiReg: item.debiRegistrationNumber,
            RevNum: item.revisionNumber ? item.revisionNumber : "",
            DisCenter: item.distributionCenter,
            store: item.store,
            BName: item.businessName,
            dealerNum: item.dealerNumber,
            tel: item.telephone,
            salesRep: item.salesRepName,
            statusReason: item.statusReason,
            FType: item.formType,
            modified: item.lastUpdatedTs,
          }))
        : [];
    } else if (props.source === SOURCE.PARTS) {
      formattedData = props.rows
        ? props.rows.map((part) => ({
            parts: part.partNumber,
            quantity: part.quantity,
            btn: "",
          }))
        : [];
    } else if (props.source === SOURCE.PARTSINSIDE) {
      formattedData = props.rows
        ? props.rows.map((part) => ({
            checkbox: "",
            partNumber: part.partNumber,
          }))
        : [];
    } else if (props.source === SOURCE.INPROGRESS) {
      formattedData = props.rows
        ? props.rows.map((item) => ({
            debiReg: item.debiRegistrationNumber,
            DisCenter: item.distributionCenter,
            store: item.store,
            BName: item.businessName,
            dealerNum: item.dealerNumber,
            tel: item.telephone,
            salesRep: item.salesRepName,
            statusReason: item.statusReason,
            FType: item.formType,
            modified: item.lastUpdatedTs,
          }))
        : [];
    } else if (props.source === SOURCE.CANCELLED) {
      formattedData = props.rows
        ? props.rows.map((item) => ({
            debiReg: item.debiRegistrationNumber,
            RevNum: item.revisionNumber ? item.revisionNumber : "",
            DisCenter: item.distributionCenter,
            store: item.store,
            BName: item.businessName,
            dealerNum: item.dealerNumber,
            tel: item.telephone,
            modified: item.createdTs,
            statusReason: item.statusReason,
          }))
        : [];
    } else if (props.source === SOURCE.HISTORY) {
      formattedData = props.rows
        ? props.rows.map((item) => ({
            debiReg: item.debiRegistrationNumber,
            RevNum: item.revisionNumber ? item.revisionNumber : "",
            DisCenter: item.distributionCenter,
            store: item.store,
            BName: item.businessName,
            dealerNum: item.dealerNumber,
            tel: item.telephone,
            salesRep: item.salesRepName,
            statusReason: item.statusReason,
            FType: item.formType,
            modified: item.lastUpdatedTs,
            status: item.statusReason === "Closed" ? "Inactive" : "Active",
          }))
        : [];
    } else if (props.source === SOURCE.PARTS_MAINTENANCE) {
      formattedData = props.rows
        ? props.rows.map((part) => ({
            checkbox: "",
            partNumber: part.partNumber,
            remarks: part.remarks,
          }))
        : [];
    } else {
      formattedData = props.rows
        ? props.rows.map((store) => ({
            checkbox: "",
            name: `${store.storeId}-${store.storeName}`,
            storeName: store.storeName,
          }))
        : [];
    }
    setFullData(formattedData);
    setRows(formattedData);
  }, [props?.source, props?.data, props?.rows]);

  React.useEffect(() => {
    if (
      props?.searchedData &&
      (props?.source === SOURCE.DC ||
        props?.source === SOURCE.STORE ||
        props?.source === SOURCE.PARTSINSIDE ||
        props?.source === SOURCE.PARTS_MAINTENANCE)
    ) {
      let tmp;
      if (props?.source === SOURCE.DC) {
        tmp = fullData?.filter(
          (itm) =>
            itm?.name
              ?.toUpperCase()
              ?.includes(props?.searchedData?.toUpperCase()) ||
            itm?.city?.toUpperCase()?.includes(props.searchedData.toUpperCase())
        );
      } else if (
        props?.source === SOURCE.PARTSINSIDE ||
        props?.source === SOURCE.PARTS_MAINTENANCE
      ) {
        tmp = fullData?.filter((itm) =>
          itm?.partNumber
            ?.toUpperCase()
            ?.includes(props?.searchedData?.toUpperCase())
        );
      } else if (props?.source === SOURCE.STORE) {
        tmp = fullData?.filter(
          (itm) =>
            itm?.name
              ?.toUpperCase()
              ?.includes(props?.searchedData?.toUpperCase()) ||
            itm?.storeName
              ?.toUpperCase()
              ?.includes(props.searchedData.toUpperCase())
        );
      }
      setRows(tmp);
    } else if (
      props?.searchedData === "" &&
      (props?.source === SOURCE.DC ||
        props?.source === SOURCE.STORE ||
        props?.source === SOURCE.PARTSINSIDE ||
        props?.source === SOURCE.PARTS_MAINTENANCE)
    ) {
      if (props.source === SOURCE.DC) {
        let formattedData = props.rows
          ? props.rows.map((dc) => ({
              checkbox: "",
              name: dc.distributionCenterName,
              city: dc.distributionCity,
            }))
          : [];
        setRows(formattedData);
      } else if (props.source === SOURCE.STORE) {
        let formattedData = props.rows
          ? props.rows.map((store) => ({
              checkbox: "",
              name: `${store.storeId}-${store.storeName}`,
              storeName: store.storeName,
            }))
          : [];
        setRows(formattedData);
      } else if (props.source === SOURCE.PARTSINSIDE) {
        let formattedData = props.rows
          ? props.rows.map((part) => ({
              checkbox: "",
              partNumber: part.partNumber,
            }))
          : [];
        setRows(formattedData);
      } else if (props.source === SOURCE.PARTS_MAINTENANCE) {
        let formattedData = props.rows
          ? props.rows.map((part) => ({
              checkbox: "",
              partNumber: part.partNumber,
              remarks: part.remarks,
            }))
          : [];
        setRows(formattedData);
      }
    }
  }, [props.searchedData]);
  const headCells =
    props?.source === SOURCE.MAIN
      ? MAIN_HEAD_CELLS
      : props.source === SOURCE.DC
      ? DC_HEAD_CELLS
      : props.source === SOURCE.PARTS
      ? PARTS_HEAD_CELLS
      : props.source === SOURCE.PARTS_MAINTENANCE
      ? PARTS_MAINTENANCE_HEAD_CELLS
      : props.source === SOURCE.PARTSINSIDE
      ? PARTS_INSIDE_HEAD_CELLS
      : props.source === SOURCE.CANCELLED
      ? CANCELLED_HEAD_CELLS
      : props.source === SOURCE.HISTORY
      ? HISTORY_HEAD_CELLS
      : STORE_HEAD_CELLS;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    let stableData = stableSort(rows, getComparator(order, orderBy));
    if (
      props?.source === SOURCE.MAIN ||
      props?.source === SOURCE.INPROGRESS ||
      props?.source === SOURCE.CANCELLED ||
      props?.source === SOURCE.HISTORY
    ) {
      stableData = rows.slice(0, rows.length);
    } else {
      stableData = stableData?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
    }
    return stableData;
  }, [order, orderBy, page, rowsPerPage, rows]);
  return (
    <>
      <Box sx={WIDTH_100}>
        {props.source !== SOURCE.MAIN &&
          props.source !== SOURCE.PARTS &&
          props.notShow !== true && (
            <Box sx={{ py: 1 }}>{CLICK_AND_SELECT_LABEL}</Box>
          )}
        <Paper sx={{ ...WIDTH_100, mb: 2 }}>
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                headCells={headCells}
                props={props.source}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rows?.length}
              />
              <TableBody>
                {visibleRows && visibleRows.length > 0 ? (
                  visibleRows.map((row, index) => {
                    return (
                      <StyledTableRow hover tabIndex={-1} key={uuidv4()}>
                        {Object.entries(row).map((item, key) => {
                          return (
                            <StyledTableCell align="left" key={uuidv4()}>
                              {(props.source === SOURCE.DC ||
                                props.source === SOURCE.STORE ||
                                props.source === SOURCE.PARTS_MAINTENANCE ||
                                props.source === SOURCE.PARTSINSIDE) &&
                              key === 0 ? (
                                <CheckboxView
                                  testid="check"
                                  checked={
                                    props.source === SOURCE.PARTSINSIDE
                                      ? props.selected.index === index &&
                                        props.selected.record.partNumber ===
                                          row.partNumber
                                      : props.source ===
                                        SOURCE.PARTS_MAINTENANCE
                                      ? props?.selected?.record?.partNumber ===
                                        row?.partNumber
                                      : props.flag === "createDebi"
                                      ? props?.selected?.record?.name ===
                                        row?.name
                                      : props?.selected?.index === index &&
                                        props?.selected?.record?.name ===
                                          row?.name
                                  }
                                  onCheck={(e) => {
                                    props.handleChecked(
                                      props.source === SOURCE.PARTS_MAINTENANCE
                                        ? row?.partNumber
                                        : row?.name,
                                      row,
                                      index
                                    );
                                  }}
                                />
                              ) : props.source !== SOURCE.PARTS && key === 0 ? (
                                <LinkView
                                  testid="details-link"
                                  onClickLink={() =>
                                    props.onRowClick(row, index)
                                  }
                                >
                                  {item[1]}
                                </LinkView>
                              ) : props.source === SOURCE.PARTS && key === 2 ? (
                                <>
                                  <Box sx={cursorPointerRelPos}>
                                    <KeyboardArrowDownIcon
                                      testid="down"
                                      onClick={() => {
                                        if (val !== "") {
                                          setVal("");
                                        } else {
                                          setVal(row.parts);
                                        }
                                      }}
                                    />
                                  </Box>
                                  {val === row.parts &&
                                    props?.username ===
                                      props?.debiDetails?.debis[0]?.createdBy &&
                                    props?.debiDetails?.debis[0]
                                      ?.statusReason !== STATUS.OPEN &&
                                    props?.debiDetails?.debis[0]
                                      ?.statusReason !== STATUS.CLOSED &&
                                    props?.debiDetails?.docusignDetails &&
                                    props?.debiDetails?.docusignDetails?.length === 0 
                                     && (
                                      <div style={partTableStyles}>
                                        <div
                                          testid="update"
                                          className="partsDrop"
                                          onClick={() => {
                                            props.updateClicked(row);
                                          }}
                                        >
                                          {UPDATE_LABEL}
                                        </div>
                                        <div
                                          testid="delete"
                                          className="partsDrop"
                                          onClick={() => {
                                            props.deleteClicked(row);
                                          }}
                                        >
                                          {DELETE_LABEL}
                                        </div>
                                      </div>
                                    )}
                                </>
                              ) : (
                                item[1]
                              )}
                            </StyledTableCell>
                          );
                        })}
                      </StyledTableRow>
                    );
                  })
                ) : (
                  <Box className="p-3">{NO_DATA_FOUND_TEXT}</Box>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            testid="pagination"
            component="div"
            count={props?.totalRows ? props?.totalRows : rows?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
};
export default DataTable;
